export default __webpack_public_path__ + "static/media/cp_geo_bw.9609a72f.svg";